import { useEffect } from "react"
import L from "leaflet"
import { useMap } from "react-leaflet";
import "./legend.css"

const LegendControl = () => {
  const map = useMap()

  useEffect(() => {
    const legend = L.control({ position: "bottomright" })

    legend.onAdd = function () {
      const div = L.DomUtil.create("div", "info legend-gradient")
      div.innerHTML = `
      <div class="legend-title">Legend</div>
      <div class="gradient-box">
        <span class="legend-label" style="top: 10%;">100%</span>
        <span class="legend-label" style="top: 50%;">50%</span>
        <span class="legend-label" style="top: 90%;">0%</span>
      </div>
    `
    
    
      return div
    }

    legend.addTo(map)

    return () => {
      legend.remove()
    }
  }, [map])

  return null
}

export default LegendControl

